var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('layout',{attrs:{"title":"Customer Aging Report"}},[_c('div',{staticClass:"px-8"},[_c('customer-statement-display',{attrs:{"statement":_vm.statement}})],1)])}
var staticRenderFns = []

export { render, staticRenderFns }